module.exports = __webpack_public_path__ + "static/media/LOGO_NEGRO.0949d840.png";